import React, { useContext, useEffect, useState } from "react";
import View from "./View";
import { Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { set_360_count } from "../store/images";
import FileContext from "../context/Context";


const InspectionSteps = () => {
  const dispatch = useDispatch();
  const { capturedInspectionImages } = useContext(FileContext);

  const imagePaths = {
    Front: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-side.svg`,
    Front_Left: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-left-side.svg`,
    Left: `${process.env.PUBLIC_URL}/inspection-car-360/car-left-side.svg`,
    Back_Left: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-left-side.svg`,
    Back: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-side.svg`,
    Back_Right: `${process.env.PUBLIC_URL}/inspection-car-360/car-back-right-side.svg`,
    Right: `${process.env.PUBLIC_URL}/inspection-car-360/car-right-side.svg`,
    Front_Right: `${process.env.PUBLIC_URL}/inspection-car-360/car-front-right-side.svg`,
    Outer_Windshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/outer-windshield.svg`,
    Inner_Winshield: `${process.env.PUBLIC_URL}/inspection-car-other-parts/inner-windshield.svg`,
    Odomter: `${process.env.PUBLIC_URL}/inspection-car-other-parts/odometer.svg`,
    RPM_Meter_Video: `${process.env.PUBLIC_URL}/inspection-car-other-parts/video.png`,
    Engine_Video: `${process.env.PUBLIC_URL}/inspection-car-other-parts/video.png`,
    Registration_No: `${process.env.PUBLIC_URL}/inspection-car-other-parts/registration-no.svg`,
    Chassis: `${process.env.PUBLIC_URL}/inspection-car-other-parts/chassis-no.svg`,
    RC: `${process.env.PUBLIC_URL}/inspection-car-other-parts/rc.svg`,
    CarView: `${process.env.PUBLIC_URL}/inspection-car-other-parts/carView.png`,

    Front_Left_Tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-left-tyre.svg`,
    Front_Right_Tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/front-right-tyre.svg`,
    Back_Right_Tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-right-tyre.svg`,
    Back_Left_Tyre: `${process.env.PUBLIC_URL}/inspection-car-other-parts/back-left-tyre.svg`,
    Selfie: `${process.env.PUBLIC_URL}/inspection-car-other-parts/selfie.svg`,
  };

  const constraints = [
    {
      viewName: "Front",
      imageName: imagePaths.Front,
      techName: "front_side",
      id: 1
    },
    {
      viewName: "Front Left",
      imageName: imagePaths.Front_Left,
      techName: "front_left_side",
      id: 2
    },
    {
      viewName: "Left",
      imageName: imagePaths.Left,
      techName: "left_side",
      id: 3
    },
    {
      viewName: "Back Left",
      imageName: imagePaths.Back_Left,
      techName: "back_left_side",
      id: 4
    },
    {
      viewName: "Back",
      imageName: imagePaths.Back,
      techName: "back_side",
      id: 5
    },
    {
      viewName: "Back Right",
      imageName: imagePaths.Back_Right,
      techName: "back_right_side",
      id: 6
    },
    {
      viewName: "Right",
      imageName: imagePaths.Right,
      techName: "right_side",
      id: 7
    },
    {
      viewName: "Front Right",
      imageName: imagePaths.Front_Right,
      techName: "front_right_side",
      id: 8
    },
    {
      viewName: "Outer Windshield",
      imageName: imagePaths.Outer_Windshield,
      techName: "outer_windshield",
      id: 9
    },
    {
      viewName: "Inner Windshield",
      imageName: imagePaths.Inner_Winshield,
      techName: "inner_windshield",
      id: 10
    },
    {
      viewName: "Odometer",
      imageName: imagePaths.Odomter,
      techName: "odometer",
      id: 11
    },
    {
      viewName: "RPM Meter Video",
      imageName: imagePaths.RPM_Meter_Video,
      techName: "rpm_meter_video",
      id: 12
    },

    {
      viewName: "Registration Plate",
      imageName: imagePaths.Registration_No,
      techName: "registrationNo",
      id: 13
    },
    {
      viewName: "Chassis No",
      imageName: imagePaths.Chassis,
      techName: "chassis",
      id: 14
    },
    {
      viewName: "RC",
      imageName: imagePaths.RC,
      techName: "RC",
      id: 15
    },

    {
      viewName: "Front Left Tyre",
      imageName: imagePaths.Front_Left_Tyre,
      techName: "front_left_tyre",
      id: 16
    },
    {
      viewName: "Back Left Tyre",
      imageName: imagePaths.Back_Left_Tyre,
      techName: "back_left_tyre",
      id: 17
    },
    {
      viewName: "Back Right Tyre",
      imageName: imagePaths.Back_Right_Tyre,
      techName: "back_right_tyre",
      id: 18
    },
    {
      viewName: "Front Right Tyre",
      imageName: imagePaths.Front_Right_Tyre,
      techName: "front_right_tyre",
      id: 19
    },
    {

      viewName: "360° View",
      imageName: imagePaths.CarView,
      techName: "360_view",
      id: 21
    },
    {
      viewName: "Selfie",
      imageName: imagePaths.Selfie,
      techName: "selfie",
      id: 20
    },

  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? "landscape" : "portrait"
  );

  useEffect(() => {
    const handleResize = () => {
      setOrientation(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
      );
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);



  useEffect(
    () => {
      if (capturedInspectionImages.length > 0 && currentImage < constraints.length) {
        setCurrentImage(capturedInspectionImages.length);
      }
    },
    [capturedInspectionImages, currentImage, constraints.length]
  );

  return (
    <Stack>
      <h2>Inspection Steps</h2>
      <Stack
        sx={{
          zIndex: 11111111,
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)", // 2 columns on extra-small screens
            sm: "repeat(21, 1fr)", // 3 columns on small screens
            md: "repeat(21, 1fr)" // 4 columns on medium screens and up
          },
          gap: "20px",
          padding: "16px",
          maxHeight: "75vh",
          overflowY: "auto",
          "@media (max-width: 600px)": {
            gridTemplateColumns: "repeat(2, 1fr)", // 2 columns for very small screens
            padding: "8px",
            gap: "8px"
          },
          "&::-webkit-scrollbar": {
            width: "5px",
            height: "6px"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ccc",
            borderRadius: "4px"
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1"
          }
        }}
      >
        {constraints.map(({ viewName, imageName, techName, id }, index) =>
          <View
            key={id}
            viewName={viewName}
            imageName={imageName}
            techName={techName}
            id={id}
            currentStep={currentImage}
            setCurrentStep={setCurrentImage}
            isCurrentStep={index === currentImage}
            sx={{
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
              cursor: "pointer",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)"
              },
              img: {
                width: "100%", // Ensure images fill the container
                height: "auto"
              }
            }}
          />
        )}
      </Stack>
    </Stack>

  );
};

export default InspectionSteps;

// 3
